import React, { useEffect, useState } from 'react'
import { Accordion, Button, Card, Col, FloatingLabel, Form, Row } from 'react-bootstrap'
import { AccordionEventKey, AccordionSelectCallback } from 'react-bootstrap/esm/AccordionContext'
import { getSBPQuestionsById, saveSBPQuestions } from '../../../../Adaptor/TUBSIS'
import { GetSBPQuestionsByIdOutput } from '../../../../Adaptor/TUBSIS/controllers/SBPQuestions/models/getSBPQuestionsModels'

type Props = { userId: number }

const PatientGeneralClinicInfo: React.FC<Props> = ({ userId }) => {

  const [profession, setProfession] = useState<string | null>(null);
  const [martialStatus, setMartialStatus] = useState<number | null>(null);
  const [educationLevel, setEducationLevel] = useState<number | null>(null);
  const [livingPlaceStatus, setLivingPlaceStatus] = useState<number | null>(null);
  const [livingPlaceStatusDesc, setLivingPlaceStatusDesc] = useState<string | null>(null);
  const [applicationAdvice, setApplicationAdvice] = useState<number | null>(null);
  const [applicationAdviceDesc, setApplicationAdviceDesc] = useState<string | null>(null);
  const [physicalHealthIssue, setPhysicalHealthIssue] = useState<number | null>(null);
  const [physicalHealthIssueDesc, setPhysicalHealthIssueDesc] = useState<string | null>(null);
  const [mentalHealthIssue, setMentalHealthIssue] = useState<number | null>(null);
  const [mentalHealthIssueDesc, setMentalHealthIssueDesc] = useState<string | null>(null);
  const [regularMedicationTherapy, setRegularMedicationTherapy] = useState<number | null>(null);
  const [regularMedicationTherapyDesc, setRegularMedicationTherapyDesc] = useState<string | null>(null);
  const [ageOfAddiction, setAgeOfAddiction] = useState<number | null>(null);
  const [startingSmokeReason, setStartingSmokeReason] = useState<string | null>(null);
  const [keepSmokeReason, setKeepSmokeReason] = useState<string | null>(null);
  const [quitSmokeReason, setQuitSmokeReason] = useState<string | null>(null);
  const [mostBothersPhysicalSymptom, setMostBothersPhysicalSymptom] = useState<number | null>(null);
  const [mostBothersPhysicalSymptomDesc, setMostBothersPhysicalSymptomDesc] = useState<string | null>(null);
  const [mostExperiencedPsychologicalState, setMostExperiencedPsychologicalState] = useState<number | null>(null);
  const [mostExperiencedPsychologicalStateDesc, setMostExperiencedPsychologicalStateDesc] = useState<string | null>(null);
  const [believeQuitSmokingPermanently, setBelieveQuitSmokingPermanently] = useState<number | null>(null);
  const [motivationOfQuittingSmokeRate, setMotivationOfQuittingSmokeRate] = useState<string | null>(null);
  const [alcoholConsumption, setAlcoholConsumption] = useState<number | null>(null);
  const [alcoholConsumptionDesc, setAlcoholConsumptionDesc] = useState<string | null>(null);
  const [drugConsumption, setDrugConsumption] = useState<number | null>(null);
  const [drugConsumptionDesc, setDrugConsumptionDesc] = useState<string | null>(null);
  const [smokingQuitIsTry, setSmokingQuitIsTry] = useState<number | null>(null);
  const [smokingQuitTryCount, setSmokingQuitTryCount] = useState<number | null>(null);
  const [difficultiesQuitSmoking, setDifficultiesQuitSmoking] = useState<number | null>(null);
  const [difficultiesQuitSmokingDesc, setDifficultiesQuitSmokingDesc] = useState<string | null>(null);
  const [startingAgainSmokingReason, setStartingAgainSmokingReason] = useState<string | null>(null);
  const [reasonOfWantingSmoke, setReasonOfWantingSmoke] = useState<number | null>(null);
  const [reasonOfWantingSmokeAlcohol, setReasonOfWantingSmokeAlcohol] = useState<boolean | null>(null);
  const [reasonOfWantingSmokeTea, setReasonOfWantingSmokeTea] = useState<boolean | null>(null);
  const [reasonOfWantingSmokeCoffee, setReasonOfWantingSmokeCoffee] = useState<boolean | null>(null);
  const [reasonOfWantingSmokeStres, setReasonOfWantingSmokeStres] = useState<boolean | null>(null);
  const [reasonOfWantingSmokeAfterDinner, setReasonOfWantingSmokeAfterDinner] = useState<boolean | null>(null);
  const [reasonOfWantingSmokeFocus, setReasonOfWantingSmokeFocus] = useState<boolean | null>(null);
  const [reasonOfWantingSmokeDesc, setReasonOfWantingSmokeDesc] = useState<string | null>(null);
  const [appliedOldMedicationNRT, setAppliedOldMedicationNRT] = useState<boolean | null>(null);
  const [appliedOldMedicationBupropion, setAppliedOldMedicationBupropion] = useState<boolean | null>(null);
  const [appliedOldMedicationCytisine, setAppliedOldMedicationCytisine] = useState<boolean | null>(null);
  const [appliedOldMedicationVareniklin, setAppliedOldMedicationVareniklin] = useState<boolean | null>(null);
  const [appliedOldMedicationDesc, setAppliedOldMedicationDesc] = useState<string | null>(null);

  const [isValidLivingPlaceStatusDesc, setIsValidLivingPlaceStatusDesc] = useState<boolean>(false);
  const [isValidApplicationAdviceDesc, setIsValidApplicationAdviceDesc] = useState<boolean>(false);
  const [isValidPhysicalHealthIssueDesc, setIsValidPhysicalHealthIssueDesc] = useState<boolean>(false);
  const [isValidMentalHealthIssueDesc, setIsValidMentalHealthIssueDesc] = useState<boolean>(false);
  const [isValidRegularMedicationTherapyDesc, setIsValidRegularMedicationTherapyDesc] = useState<boolean>(false);
  const [isValidMostBothersPhysicalSymptomDesc, setIsValidMostBothersPhysicalSymptomDesc] = useState<boolean>(false);
  const [isValidMostExperiencedPsychologicalStateDesc, setIsValidMostExperiencedPsychologicalStateDesc] = useState<boolean>(false);
  const [isValidAlcoholConsumptionDesc, setIsValidAlcoholConsumptionDesc] = useState<boolean>(false);
  const [isValidDrugConsumptionDesc, setIsValidDrugConsumptionDesc] = useState<boolean>(false);
  const [isValidSmokingQuitTryCount, setIsValidSmokingQuitTryCount] = useState<boolean>(false);
  const [isValidDifficultiesQuitSmokingDesc, setIsValidDifficultiesQuitSmokingDesc] = useState<boolean>(false);
  const [isValidReasonOfWantingSmokeDesc, setIsValidReasonOfWantingSmokeDesc] = useState<boolean>(false);

  const [activeAccordion, setActiveAccordion] = useState<AccordionEventKey | null>(null)

  const toggleAccordion: AccordionSelectCallback = (eventKey: AccordionEventKey) => {
    setActiveAccordion(eventKey === activeAccordion ? null : eventKey)
  }

  const [sbpQuestions, setSBPQuestions] = useState<GetSBPQuestionsByIdOutput | null>(null)

  useEffect(() => {
    //console.log("uid", userId)
    if (userId && userId > 0) {
      getSBPQuestionsById(userId)
        .then((response) => {

          setSBPQuestions(response.data)

          setProfession(response.data?.profession ?? '')
          setEducationLevel(response.data?.educationLevel ?? 9000)
          setMartialStatus(response.data?.martialStatus ?? 11000)
          setLivingPlaceStatus(response.data?.livingPlaceStatus ?? 14000)
          setIsValidLivingPlaceStatusDesc(response.data?.livingPlaceStatus && response.data?.livingPlaceStatus === 14008 ? true : false)
          setLivingPlaceStatusDesc(response.data?.livingPlaceStatusDesc ?? '')
          setApplicationAdvice(response.data?.applicationAdvice ?? 22000)
          setIsValidApplicationAdviceDesc(response.data?.applicationAdvice && response.data?.applicationAdvice === 22004 ? true : false)
          setApplicationAdviceDesc(response.data?.applicationAdviceDesc ?? '')
          setPhysicalHealthIssue(response.data?.physicalHealthIssue ?? 20000);
          setIsValidPhysicalHealthIssueDesc(response.data?.physicalHealthIssue && response.data?.physicalHealthIssue === 20003 ? true : false)
          setPhysicalHealthIssueDesc(response.data?.physicalHealthIssueDesc ?? '')
          setMentalHealthIssue(response.data?.mentalHealthIssue ?? 20000);
          setIsValidMentalHealthIssueDesc(response.data?.mentalHealthIssue && response.data?.mentalHealthIssue === 20003 ? true : false)
          setMentalHealthIssueDesc(response.data?.mentalHealthIssueDesc ?? '')
          setRegularMedicationTherapy(response.data?.regularMedicationTherapy ?? 20000);
          setIsValidRegularMedicationTherapyDesc(response.data?.regularMedicationTherapy && response.data?.regularMedicationTherapy === 20003 ? true : false)
          setRegularMedicationTherapyDesc(response.data?.regularMedicationTherapyDesc ?? '')
          setAgeOfAddiction(response.data?.ageOfAddiction ?? 0);
          setStartingSmokeReason(response.data?.startingSmokeReason ?? '');
          setQuitSmokeReason(response.data?.quitSmokeReason ?? '');
          setKeepSmokeReason(response.data?.keepSmokeReason ?? '');
          setMostBothersPhysicalSymptom(response.data?.mostBothersPhysicalSymptom ?? 23000);
          setIsValidMostBothersPhysicalSymptomDesc(response.data?.mostBothersPhysicalSymptom && response.data?.mostBothersPhysicalSymptom === 23005 ? true : false)
          setMostBothersPhysicalSymptomDesc(response.data?.mostBothersPhysicalSymptomDesc ?? '')
          setMostExperiencedPsychologicalState(response.data?.mostExperiencedPsychologicalState ?? 24000);
          setIsValidMostExperiencedPsychologicalStateDesc(response.data?.mostExperiencedPsychologicalState && response.data?.mostExperiencedPsychologicalState === 24006 ? true : false)
          setMostExperiencedPsychologicalStateDesc(response.data?.mostExperiencedPsychologicalStateDesc ?? '')
          setBelieveQuitSmokingPermanently(response.data?.believeQuitSmokingPermanently ?? 20000);
          setMotivationOfQuittingSmokeRate(response.data?.motivationOfQuittingSmokeRate ?? '');
          setAlcoholConsumption(response.data?.alcoholConsumption ?? 20000);
          setIsValidAlcoholConsumptionDesc(response.data?.alcoholConsumption && response.data?.alcoholConsumption === 20003 ? true : false)
          setAlcoholConsumptionDesc(response.data?.alcoholConsumptionDesc ?? '')
          setDrugConsumption(response.data?.drugConsumption ?? 20000);
          setIsValidDrugConsumptionDesc(response.data?.drugConsumption && response.data?.drugConsumption === 20003 ? true : false)
          setDrugConsumptionDesc(response.data?.drugConsumptionDesc ?? '');
          setSmokingQuitIsTry(response.data?.smokingQuitIsTry ?? 0);
          setIsValidSmokingQuitTryCount(response.data?.smokingQuitIsTry && response.data?.smokingQuitIsTry === 20003 ? true : false)
          setDifficultiesQuitSmoking(response.data?.difficultiesQuitSmoking ?? 20000);
          setIsValidDifficultiesQuitSmokingDesc(response.data?.difficultiesQuitSmoking && response.data?.difficultiesQuitSmoking === 20003 ? true : false)
          setDifficultiesQuitSmokingDesc(response.data?.difficultiesQuitSmokingDesc ?? '')
          setStartingAgainSmokingReason(response.data?.startingAgainSmokingReason ?? '');
          
          setReasonOfWantingSmokeAlcohol(response?.data?.reasonOfWantingSmokeAlcohol ?? false);
          setReasonOfWantingSmokeTea(response?.data?.reasonOfWantingSmokeTea ?? false);
          setReasonOfWantingSmokeCoffee(response?.data?.reasonOfWantingSmokeCoffee ?? false);
          setReasonOfWantingSmokeStres(response?.data?.reasonOfWantingSmokeStres ?? false);
          setReasonOfWantingSmokeAfterDinner(response?.data?.reasonOfWantingSmokeAfterDinner ?? false);
          setReasonOfWantingSmokeFocus(response?.data?.reasonOfWantingSmokeFocus ?? false);
          setReasonOfWantingSmokeDesc(response.data?.reasonOfWantingSmokeDesc ?? '')
          
          if (response?.data?.reasonOfWantingSmoke == 25001 || response?.data?.reasonOfWantingSmokeAlcohol) {
            setReasonOfWantingSmokeAlcohol(true);
          } else if (response?.data?.reasonOfWantingSmoke == 25002 || response?.data?.reasonOfWantingSmokeTea) {
            setReasonOfWantingSmokeTea(true);
          } else if (response?.data?.reasonOfWantingSmoke == 25003 || response?.data?.reasonOfWantingSmokeCoffee) {
            setReasonOfWantingSmokeCoffee(true);
          } else if (response?.data?.reasonOfWantingSmoke == 25004 || response?.data?.reasonOfWantingSmokeStres) {
            setReasonOfWantingSmokeStres(true);
          } else if (response?.data?.reasonOfWantingSmoke == 25005 || response?.data?.reasonOfWantingSmokeAfterDinner) {
            setReasonOfWantingSmokeAfterDinner(true);
          } else if (response?.data?.reasonOfWantingSmoke == 25006 || response?.data?.reasonOfWantingSmokeFocus) {
            setReasonOfWantingSmokeFocus(true);
          } 

          setReasonOfWantingSmoke(null);//Eski datayı yeni dataya merge etmek için kullanılıyor. Sonraki versiyonda kaldırılmalıdır.

          setAppliedOldMedicationDesc(response.data?.appliedOldMedicationDesc ?? '');
          setAppliedOldMedicationNRT(response.data?.appliedOldMedicationNRT ?? false);
          setAppliedOldMedicationBupropion(response.data?.appliedOldMedicationBupropion ?? false);
          setAppliedOldMedicationCytisine(response.data?.appliedOldMedicationCytisine ?? false);
          setAppliedOldMedicationVareniklin(response.data?.appliedOldMedicationVareniklin ?? false);

          // console.log("sbp",response.data)
        })
        .catch((error) => {
          console.error("Error fetching user:", error);
        });
    }
  }, [userId]);

  const handleSave = async () => {
    // Form verilerini güncellemek için gerekli işlemleri burada gerçekleştirin
    // console.log("Form verileri güncellendi:", userData);

    if (!isValidAge || !isValidMotivationRate) {
      return;
    }

    const requestModel = {
      userId: userId,
      profession: profession ?? "",
      martialStatus: martialStatus ?? 11000,
      educationLevel: educationLevel ?? 9000,
      livingPlaceStatus: livingPlaceStatus ?? 14000,
      livingPlaceStatusDesc: livingPlaceStatusDesc && livingPlaceStatus === 14008 ? livingPlaceStatusDesc : "",
      applicationAdvice: applicationAdvice ?? 22000,
      applicationAdviceDesc: applicationAdviceDesc && applicationAdvice === 22004 ? applicationAdviceDesc : "",
      physicalHealthIssue: physicalHealthIssue ?? 20000,
      physicalHealthIssueDesc: physicalHealthIssueDesc && physicalHealthIssue === 20003 ? physicalHealthIssueDesc : "",
      mentalHealthIssue: mentalHealthIssue ?? 20000,
      mentalHealthIssueDesc: mentalHealthIssueDesc && mentalHealthIssue === 20003 ? mentalHealthIssueDesc : "",
      regularMedicationTherapy: regularMedicationTherapy ?? 20000,
      regularMedicationTherapyDesc: regularMedicationTherapyDesc && regularMedicationTherapy === 20003 ? regularMedicationTherapyDesc : "",
      ageOfAddiction: ageOfAddiction ?? 0,
      startingSmokeReason: startingSmokeReason ?? "",
      keepSmokeReason: keepSmokeReason ?? "",
      quitSmokeReason: quitSmokeReason ?? "",
      mostBothersPhysicalSymptom: mostBothersPhysicalSymptom ?? 23000,
      mostBothersPhysicalSymptomDesc: mostBothersPhysicalSymptomDesc && mostBothersPhysicalSymptom === 23005 ? mostBothersPhysicalSymptomDesc : "",
      mostExperiencedPsychologicalState: mostExperiencedPsychologicalState ?? 24000,
      mostExperiencedPsychologicalStateDesc: mostExperiencedPsychologicalStateDesc && mostExperiencedPsychologicalState === 24006 ? mostExperiencedPsychologicalStateDesc : "",
      believeQuitSmokingPermanently: believeQuitSmokingPermanently ?? 20000,
      believeQuitSmokingPermanentlyDesc: "",
      motivationOfQuittingSmokeRate: motivationOfQuittingSmokeRate ? motivationOfQuittingSmokeRate.toString() : "",
      alcoholConsumption: alcoholConsumption ?? 20000,
      alcoholConsumptionDesc: alcoholConsumptionDesc && alcoholConsumption === 20003 ? alcoholConsumptionDesc : "",
      drugConsumption: drugConsumption ?? 20000,
      drugConsumptionDesc: drugConsumptionDesc && drugConsumption === 20003 ? drugConsumptionDesc : "",
      smokingQuitIsTry: smokingQuitIsTry ?? 20000,
      smokingQuitTryCount: smokingQuitTryCount ?? 0,
      difficultiesQuitSmoking: difficultiesQuitSmoking ?? 20000,
      difficultiesQuitSmokingDesc: difficultiesQuitSmokingDesc && difficultiesQuitSmoking === 20003 ? difficultiesQuitSmokingDesc : "",
      startingAgainSmokingReason: startingAgainSmokingReason ?? "",
      reasonOfWantingSmoke: reasonOfWantingSmoke ?? 25000,
      reasonOfWantingSmokeAlcohol: reasonOfWantingSmokeAlcohol ?? false,
      reasonOfWantingSmokeTea: reasonOfWantingSmokeTea ?? false,
      reasonOfWantingSmokeCoffee: reasonOfWantingSmokeCoffee ?? false,
      reasonOfWantingSmokeStres: reasonOfWantingSmokeStres ?? false,
      reasonOfWantingSmokeAfterDinner: reasonOfWantingSmokeAfterDinner ?? false,
      reasonOfWantingSmokeFocus: reasonOfWantingSmokeFocus ?? false,
      reasonOfWantingSmokeDesc: reasonOfWantingSmokeDesc ?? "",
      appliedOldMedicationNRT: appliedOldMedicationNRT ?? false,
      appliedOldMedicationBupropion: appliedOldMedicationBupropion ?? false,
      appliedOldMedicationCytisine: appliedOldMedicationCytisine ?? false,
      appliedOldMedicationVareniklin: appliedOldMedicationVareniklin ?? false,
      appliedOldMedicationDesc: appliedOldMedicationDesc ?? ""
    }

    // console.log(JSON.stringify(requestModel))

    var response = await saveSBPQuestions(requestModel);

    if (response.success) {
      alert('Genel Poliklinik Bilgileri Kaydedildi.')
    } else {
      alert(response.message)
    }

    // window.location.reload()
  }

  const [isValidMotivationRate, setIsValidMotivationRate] = useState<boolean>(true);
  const [isValidAge, setIsValidAge] = useState<boolean>(true);

  const handleItemChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    if (name === 'profession') {
      setProfession(value);
    } else if (name === 'educationLevel') {
      setEducationLevel(parseInt(value));
    } else if (name === 'martialStatus') {
      // console.log("burada", value)
      setMartialStatus(parseInt(value));
    } else if (name === 'livingPlaceStatus') {
      setLivingPlaceStatus(parseInt(value));
      if (parseInt(value) === 14008) {
        setIsValidLivingPlaceStatusDesc(true)
      } else {
        setIsValidLivingPlaceStatusDesc(false)
      }
    } else if (name === 'livingPlaceStatusDesc') {
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
      setLivingPlaceStatusDesc(value);
    } else if (name === 'applicationAdvice') {
      setApplicationAdvice(parseInt(value));
      if (parseInt(value) === 22004) {
        setIsValidApplicationAdviceDesc(true)
      } else {
        setIsValidApplicationAdviceDesc(false)
      }
    } else if (name === 'applicationAdviceDesc') {
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
      setApplicationAdviceDesc(value);
    } else if (name === 'physicalHealthIssue') {
      setPhysicalHealthIssue(parseInt(value));
      if (parseInt(value) === 20003) {
        setIsValidPhysicalHealthIssueDesc(true)
      } else {
        setIsValidPhysicalHealthIssueDesc(false)
      }
    } else if (name === 'physicalHealthIssueDesc') {
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
      setPhysicalHealthIssueDesc(value);
    } else if (name === 'mentalHealthIssue') {
      setMentalHealthIssue(parseInt(value));
      if (parseInt(value) === 20003) {
        setIsValidMentalHealthIssueDesc(true)
      } else {
        setIsValidMentalHealthIssueDesc(false)
      }
    } else if (name === 'mentalHealthIssueDesc') {
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
      setMentalHealthIssueDesc(value);
    } else if (name === 'regularMedicationTherapy') {
      setRegularMedicationTherapy(parseInt(value));
      if (parseInt(value) === 20003) {
        setIsValidRegularMedicationTherapyDesc(true)
      } else {
        setIsValidRegularMedicationTherapyDesc(false)
      }
    } else if (name === 'regularMedicationTherapyDesc') {
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
      setRegularMedicationTherapyDesc(value);
    } else if (name === 'ageOfAddiction') {
      const pattern = /^(?:[1-9]|[1-9][0-9]?)?$/;
      setIsValidAge(pattern.test(value));
      setAgeOfAddiction(parseInt(value));
    } else if (name === 'startingSmokeReason') {
      setStartingSmokeReason(value);
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
    } else if (name === 'quitSmokeReason') {
      setQuitSmokeReason(value);
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
    } else if (name === 'keepSmokeReason') {
      setKeepSmokeReason(value);
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
    } else if (name === 'mostBothersPhysicalSymptom') {
      setMostBothersPhysicalSymptom(parseInt(value));
      if (parseInt(value) === 23005) {
        setIsValidMostBothersPhysicalSymptomDesc(true)
      } else {
        setIsValidMostBothersPhysicalSymptomDesc(false)
      }
    } else if (name === 'mostBothersPhysicalSymptomDesc') {
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
      setMostBothersPhysicalSymptomDesc(value);
    } else if (name === 'mostExperiencedPsychologicalState') {
      setMostExperiencedPsychologicalState(parseInt(value));
      if (parseInt(value) === 24006) {
        setIsValidMostExperiencedPsychologicalStateDesc(true)
      } else {
        setIsValidMostExperiencedPsychologicalStateDesc(false)
      }
    } else if (name === 'mostExperiencedPsychologicalStateDesc') {
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
      setMostExperiencedPsychologicalStateDesc(value);
    } else if (name === 'believeQuitSmokingPermanently') {
      setBelieveQuitSmokingPermanently(parseInt(value));
    } else if (name === 'motivationOfQuittingSmokeRate') {
      const pattern = /^(?:[1-9]|10)?$/;
      setIsValidMotivationRate(pattern.test(value));
      setMotivationOfQuittingSmokeRate(value);
    } else if (name === 'alcoholConsumption') {
      setAlcoholConsumption(parseInt(value));
      if (parseInt(value) === 20003) {
        setIsValidAlcoholConsumptionDesc(true)
      } else {
        setIsValidAlcoholConsumptionDesc(false)
      }
    } else if (name === 'alcoholConsumptionDesc') {
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
      setAlcoholConsumptionDesc(value);
    } else if (name === 'drugConsumptionDesc') {
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
      setDrugConsumptionDesc(value);
    } else if (name === 'drugConsumption') {
      setDrugConsumption(parseInt(value));
      if (parseInt(value) === 20003) {
        setIsValidDrugConsumptionDesc(true)
      } else {
        setIsValidDrugConsumptionDesc(false)
      }
    } else if (name === 'smokingQuitIsTry') {
      setSmokingQuitIsTry(parseInt(value))
      if (parseInt(value) === 20003) {
          setIsValidSmokingQuitTryCount(true)
      } else {
          setIsValidSmokingQuitTryCount(false)
      }
    } else if (name === 'smokingQuitTryCount') {
        setSmokingQuitTryCount(parseInt(value))
    } else if (name === 'difficultiesQuitSmoking') {
      setDifficultiesQuitSmoking(parseInt(value));
      if (parseInt(value) === 20003) {
        setIsValidDifficultiesQuitSmokingDesc(true)
      } else {
        setIsValidDifficultiesQuitSmokingDesc(false)
      }
    } else if (name === 'difficultiesQuitSmokingDesc') {
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
      setDifficultiesQuitSmokingDesc(value);
    } else if (name === 'startingAgainSmokingReason') {
      setStartingAgainSmokingReason(value);
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
    } else if (name === 'reasonOfWantingSmokeDesc') {
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
      setReasonOfWantingSmokeDesc(value);
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
    } else if (name === 'appliedOldMedicationDesc') {
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
      setAppliedOldMedicationDesc(value);
    } else {
      // console.log("hayır burada", value)
    }
  };

  const handleCheckBoxItemChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked, type } = e.target;
    if (type === 'checkbox' && name === 'appliedOldMedicationNRT') {
      setAppliedOldMedicationNRT(checked);
    } else if (type === 'checkbox' && name === 'appliedOldMedicationBupropion') {
      setAppliedOldMedicationBupropion(checked);
    } else if (type === 'checkbox' && name === 'appliedOldMedicationCytisine') {
      setAppliedOldMedicationCytisine(checked);
    } else if (type === 'checkbox' && name === 'appliedOldMedicationVareniklin') {
      setAppliedOldMedicationVareniklin(checked);
    } else if (type === 'checkbox' && name === 'reasonOfWantingSmokeAlcohol') {
      setReasonOfWantingSmokeAlcohol(checked);
    } else if (type === 'checkbox' && name === 'reasonOfWantingSmokeCoffee') {
      setReasonOfWantingSmokeCoffee(checked);
    } else if (type === 'checkbox' && name === 'reasonOfWantingSmokeTea') {
      setReasonOfWantingSmokeTea(checked);
    } else if (type === 'checkbox' && name === 'reasonOfWantingSmokeStres') {
      setReasonOfWantingSmokeStres(checked);
    } else if (type === 'checkbox' && name === 'reasonOfWantingSmokeAfterDinner') {
      setReasonOfWantingSmokeAfterDinner(checked);
    } else if (type === 'checkbox' && name === 'reasonOfWantingSmokeFocus') {
      setReasonOfWantingSmokeFocus(checked);
    }
  };

  return (
    <Accordion activeKey={activeAccordion} onSelect={toggleAccordion}>
      <Card key={1}>
        <Card.Header>
          <div className='d-flex justify-content-between align-items-center w-100'>
            <Button
              className='d-flex justify-content-between align-items-center w-100'
              variant='link'
              onClick={(e) => toggleAccordion('index.toString()', e)}
            >
              <div className='text-left text-gray-700'>GENEL POLİKLİNİK BİLGİLERİ</div>
            </Button>
          </div>
        </Card.Header>
        <Accordion.Collapse eventKey={'index.toString()'}>
          <Card.Body>
            <Form onSubmit={handleSave}>
              <Row className='mt-3'>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='profession' className='text-gray-600' label='Meslek'>
                    <Form.Control
                      className='mt-2'
                      type='textarea'
                      as='textarea'
                      name='profession'
                      value={profession ?? ''}
                      onChange={handleItemChange}
                    />
                  </FloatingLabel>
                </Form.Group>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='martialStatusLbl' label='Medeni Durumu'>
                    <Form.Select
                      className='mt-2'
                      name='martialStatus'
                      value={martialStatus ?? 11000}
                      onChange={handleItemChange}
                    >
                      <option value='11000'>Seçiniz</option>
                      <option value='11001'>Bekar</option>
                      <option value='11002'>Evli</option>
                      <option value='11003'>Boşanmış</option>
                      <option value='11005'>Ayrı</option>
                      <option value='11004'>Dul (eşi vefat etmiş)</option>
                    </Form.Select>
                  </FloatingLabel>
                </Form.Group>
              </Row>

              <Row className='mt-3'>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='educationLevel' label='Eğitim Durumu'>
                    <Form.Select
                      className='mt-2'
                      name='educationLevel'
                      value={educationLevel ?? 9000}
                      onChange={handleItemChange}
                    >
                      <option value='9000'>Seçiniz</option>
                      <option value='9001'>Lisansüstü Mezunu</option>
                      <option value='9002'>Lisans Mezunu</option>
                      <option value='9003'>Önlisans Mezunu</option>
                      <option value='9004'>Lise Mezunu</option>
                      <option value='9005'>Ortaokul Mezunu</option>
                      <option value='9006'>İlkokul Mezunu</option>
                      <option value='9008'>Okur/Yazar Değil</option>
                    </Form.Select>
                  </FloatingLabel>
                </Form.Group>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='livingPlaceStatus' label='Kiminle yaşıyor?'>
                    <Form.Select
                      className='mt-2'
                      name='livingPlaceStatus'
                      value={livingPlaceStatus ?? 14000}
                      onChange={handleItemChange}
                    >
                      <option value='14000'>Seçiniz</option>
                      <option value='14001'>Yurtta tek başıma</option>
                      <option value='14002'>Yurtta arkadaşımla</option>
                      <option value='14003'>Evde tek başıma</option>
                      <option value='14004'>Evde arkadaşımla</option>
                      <option value='14005'>Evde eşim ve (varsa) çocuklarımla</option>
                      <option value='14006'>Evde annem/babam/kardeşimle</option>
                      <option value='14007'>Evde akrabamla</option>
                      <option value='14008'>Diğer</option>
                    </Form.Select>
                  </FloatingLabel>
                  <Form.Control
                    className='mt-2'
                    name="livingPlaceStatusDesc"
                    value={livingPlaceStatusDesc ?? ''}
                    type='textarea'
                    as='textarea'
                    placeholder='Lütfen belirtiniz...'
                    hidden={!isValidLivingPlaceStatusDesc}
                    onChange={handleItemChange}
                  />
                </Form.Group>
              </Row>

              <Row className='mt-3'>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='applicationAdvice' label='Başvuru'>
                    <Form.Select
                      className='mt-2'
                      name='applicationAdvice'
                      value={applicationAdvice ?? 22000}
                      onChange={handleItemChange}
                    >
                      <option value='22000'>Seçiniz</option>
                      <option value='22001'>Doktor Önerisi</option>
                      <option value='22002'>Çevre Önerisi</option>
                      <option value='22003'>Kendi İsteği</option>
                      <option value='22004'>Diğer</option>
                    </Form.Select>
                  </FloatingLabel>
                  <Form.Control
                    name='applicationAdviceDesc'
                    value={applicationAdviceDesc ?? ''}
                    className='mt-2'
                    type='textarea'
                    as='textarea'
                    placeholder='Lütfen belirtiniz...'
                    hidden={!isValidApplicationAdviceDesc}
                    onChange={handleItemChange}
                  />
                </Form.Group>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='physicalHealthIssue' label='Bedensel Sağlık Sorunu'>
                    <Form.Select
                      className='mt-2'
                      name='physicalHealthIssue'
                      value={physicalHealthIssue ?? 20000}
                      onChange={handleItemChange}
                    >
                      <option value='20000'>Seçiniz</option>
                      <option value='20003'>Var</option>
                      <option value='20002'>Yok</option>
                    </Form.Select>
                  </FloatingLabel>
                  <Form.Control
                    className='mt-2'
                    name='physicalHealthIssueDesc'
                    value={physicalHealthIssueDesc ?? ''}
                    type='textarea'
                    as='textarea'
                    placeholder='Lütfen belirtiniz...'
                    hidden={!isValidPhysicalHealthIssueDesc}
                    onChange={handleItemChange}
                  />
                </Form.Group>
              </Row>
              <Row className='mt-3'>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='mentalHealthIssue' label='Ruh Sağlığı Sorunu'>
                    <Form.Select
                      className='mt-2'
                      name='mentalHealthIssue'
                      value={mentalHealthIssue ?? 20000}
                      onChange={handleItemChange}
                    >
                      <option value='20000'>Seçiniz</option>
                      <option value='20003'>Var</option>
                      <option value='20002'>Yok</option>
                    </Form.Select>
                  </FloatingLabel>
                  <Form.Control
                    className='mt-2'
                    name='mentalHealthIssueDesc'
                    value={mentalHealthIssueDesc ?? ''}
                    type='textarea'
                    as='textarea'
                    placeholder='Lütfen belirtiniz...'
                    hidden={!isValidMentalHealthIssueDesc}
                    onChange={handleItemChange}
                  />
                </Form.Group>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='regularMedicationTherapy' label='Düzenli İlaç-Tedavi'>
                    <Form.Select
                      className='mt-2'
                      name='regularMedicationTherapy'
                      value={regularMedicationTherapy ?? 20000}
                      onChange={handleItemChange}
                    >
                      <option value='20000'>Seçiniz</option>
                      <option value='20003'>Var</option>
                      <option value='20002'>Yok</option>
                    </Form.Select>
                  </FloatingLabel>
                  <Form.Control
                    className='mt-2'
                    type='textarea'
                    as='textarea'
                    name='regularMedicationTherapyDesc'
                    value={regularMedicationTherapyDesc ?? ''}
                    placeholder='Lütfen belirtiniz...'
                    hidden={!isValidRegularMedicationTherapyDesc}
                    onChange={handleItemChange}
                  />
                </Form.Group>
              </Row>

              <Row className='mt-3'>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='ageOfAddiction' className='text-gray-600' label='Düzenli olarak sigaraya başlama yaşı?'>
                    <Form.Control
                      className='mt-2'
                      type='text'
                      name='ageOfAddiction'
                      value={!ageOfAddiction || ageOfAddiction === 0 ? '' : ageOfAddiction}
                      onChange={handleItemChange}
                      isInvalid={!isValidAge}
                    />
                    <Form.Control.Feedback type="invalid">
                      Lütfen sadece sayı girişi yapınız.
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Form.Group>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='startingSmokeReason' className='text-gray-600' label='Sigaraya başlama nedeni nedir?'>
                    <Form.Control
                      className='mt-2'
                      type='textarea'
                      as='textarea'
                      name='startingSmokeReason'
                      value={startingSmokeReason ?? ''}
                      onChange={handleItemChange}
                    />
                  </FloatingLabel>
                </Form.Group>
              </Row>

              <Row className='mt-3'>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='keepSmokeReason' className='text-gray-600' label='Sigaraya devam etme nedeniniz nedir?'>
                    <Form.Control
                      className='mt-2'
                      type='textarea'
                      as='textarea'
                      name='keepSmokeReason'
                      value={keepSmokeReason ?? ''}
                      onChange={handleItemChange}
                    />
                  </FloatingLabel>
                </Form.Group>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='quitSmokeReason' className='text-gray-600' label='Sigarayı neden bırakmak istiyorsunuz?'>
                    <Form.Control
                      className='mt-2'
                      type='textarea'
                      as='textarea'
                      name='quitSmokeReason'
                      value={quitSmokeReason ?? ''}
                      onChange={handleItemChange}
                    />
                  </FloatingLabel>
                </Form.Group>
              </Row>

              <Row className='mt-3'>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='mostBothersPhysicalSymptom' label='Sizi en çok hangi fiziksel belirti rahatsız ediyor?'>
                    <Form.Select
                      className='mt-2'
                      name='mostBothersPhysicalSymptom'
                      value={mostBothersPhysicalSymptom ?? 23000}
                      onChange={handleItemChange}
                    >
                      <option value='23000'>Seçiniz</option>
                      <option value='23001'>Öksürük/Balgam</option>
                      <option value='23002'>Güç Kaybı</option>
                      <option value='23003'>Nefes Darlığı</option>
                      <option value='23004'>Göğüs Ağrısı</option>
                      <option value='23005'>Diğer</option>
                    </Form.Select>
                  </FloatingLabel>
                  <Form.Control
                    className='mt-2'
                    type='textarea'
                    as='textarea'
                    placeholder='Lütfen belirtiniz...'
                    name='mostBothersPhysicalSymptomDesc'
                    hidden={!isValidMostBothersPhysicalSymptomDesc}
                    value={mostBothersPhysicalSymptomDesc ?? ''}
                    onChange={handleItemChange}
                  />
                </Form.Group>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='mostExperiencedPsychologicalState' label='En çok hangi psikolojik durumu deneyimliyorsunuz?'>
                    <Form.Select
                      className='mt-2'
                      name='mostExperiencedPsychologicalState'
                      value={mostExperiencedPsychologicalState ?? 24000}
                      onChange={handleItemChange}
                    >
                      <option value='24000'>Seçiniz</option>
                      <option value='24001'>Uyku Kalitesinde Azalma</option>
                      <option value='24002'>Odaklanma Problemi</option>
                      <option value='24003'>Endişe</option>
                      <option value='24004'>Stres/Gerginlik</option>
                      <option value='24005'>Sinirlilik/Öfke</option>
                      <option value='24006'>Diğer</option>
                    </Form.Select>
                  </FloatingLabel>
                  <Form.Control
                    className='mt-2'
                    type='textarea'
                    as='textarea'
                    placeholder='Lütfen belirtiniz...'
                    name='mostExperiencedPsychologicalStateDesc'
                    hidden={!isValidMostExperiencedPsychologicalStateDesc}
                    value={mostExperiencedPsychologicalStateDesc ?? ''}
                    onChange={handleItemChange}
                  />
                </Form.Group>
              </Row>

              <Row className='mt-3'>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='believeQuitSmokingPermanently' label='Sigarayı kalıcı olarak bırakabileceğinize inanıyor musunuz?'>
                    <Form.Select
                      className='mt-2'
                      name='believeQuitSmokingPermanently'
                      value={believeQuitSmokingPermanently ?? 20000}
                      onChange={handleItemChange}
                    >
                      <option value='20000'>Seçiniz</option>
                      <option value='20003'>Evet</option>
                      <option value='20002'>Hayır</option>
                    </Form.Select>
                  </FloatingLabel>
                </Form.Group>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='motivationOfQuittingSmokeRate' className='text-gray-600' label='Sigarayı bırakma motivasyonunuz 1-10 arasında kaçtır?'>
                    <Form.Control
                      className='mt-2'
                      type='text'
                      name='motivationOfQuittingSmokeRate'
                      value={motivationOfQuittingSmokeRate ?? ''}
                      isInvalid={!isValidMotivationRate}
                      onChange={handleItemChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Lütfen 1-10 arasında bir sayı giriniz.
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Form.Group>
              </Row>

              <Row className='mt-3'>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='alcoholConsumption' label='Alkol Kullanımı'>
                    <Form.Select
                      className='mt-2'
                      name='alcoholConsumption'
                      value={alcoholConsumption ?? 20000}
                      onChange={handleItemChange}
                    >
                      <option value='20000'>Seçiniz</option>
                      <option value='20003'>Var</option>
                      <option value='20002'>Yok</option>
                    </Form.Select>
                  </FloatingLabel>
                  <Form.Control
                    className='mt-2'
                    type='textarea'
                    as='textarea'
                    placeholder='Lütfen belirtiniz...'
                    name='alcoholConsumptionDesc'
                    hidden={!isValidAlcoholConsumptionDesc}
                    value={alcoholConsumptionDesc ?? ''}
                    onChange={handleItemChange}
                  />
                </Form.Group>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='drugConsumption' label='Madde Kullanımı'>
                    <Form.Select
                      className='mt-2'
                      name='drugConsumption'
                      value={drugConsumption ?? 20000}
                      onChange={handleItemChange}
                    >
                      <option value='20000'>Seçiniz</option>
                      <option value='20003'>Var</option>
                      <option value='20002'>Yok</option>
                    </Form.Select>
                  </FloatingLabel>
                  <Form.Control
                    className='mt-2'
                    type='textarea'
                    as='textarea'
                    placeholder='Lütfen belirtiniz...'
                    name='drugConsumptionDesc'
                    hidden={!isValidDrugConsumptionDesc}
                    value={drugConsumptionDesc ?? ''}
                    onChange={handleItemChange}
                  />
                </Form.Group>
              </Row>

              <Row className='mt-3'>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='smokingQuitIsTry' label='Hiç Sigarayı Bırakma Girişimi Oldu Mu?'>
                    <Form.Select
                      className='mt-2'
                      name='smokingQuitIsTry'
                      value={smokingQuitIsTry ?? 20000}
                      onChange={handleItemChange}
                    >
                      <option value='20000'>Seçiniz</option>
                      <option value='20003'>Evet</option>
                      <option value='20002'>Hayır</option>
                    </Form.Select>
                  </FloatingLabel>
                  {isValidSmokingQuitTryCount ? (
                      <Form.Control
                          type='text'
                          placeholder='... kere denedim/bıraktım.'
                          name='smokingQuitTryCount'
                          value={!smokingQuitTryCount || smokingQuitTryCount === 0 ? '' : smokingQuitTryCount}
                          onChange={handleItemChange}
                      // hidden={!isValidSmokingQuitTryCount}
                      />
                  ) : (
                      <Form.Control
                          type='text'
                          readOnly
                          style={{ border: "none" }}
                      />
                  )}
                  
                </Form.Group>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='difficultiesQuitSmoking' label='Bırakma girişiminde hangi güçlüklerle karşılaştınız?'>
                    <Form.Select
                      className='mt-2'
                      name='difficultiesQuitSmoking'
                      value={difficultiesQuitSmoking ?? 20000}
                      onChange={handleItemChange}
                    >
                      <option value='20000'>Seçiniz</option>
                      <option value='20003'>Var</option>
                      <option value='20002'>Yok</option>
                    </Form.Select>
                  </FloatingLabel>
                  <Form.Control
                    className='mt-2'
                    type='textarea'
                    as='textarea'
                    placeholder='Lütfen belirtiniz...'
                    name='difficultiesQuitSmokingDesc'
                    hidden={!isValidDifficultiesQuitSmokingDesc}
                    value={difficultiesQuitSmokingDesc ?? ''}
                    onChange={handleItemChange}
                  />
                </Form.Group>
              </Row>

              <Row className='mt-3'>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='startingAgainSmokingReason' className='text-gray-600' label='Tekrar başlama nedeni?'>
                    <Form.Control
                      className='mt-2'
                      type='textarea'
                      as="textarea"
                      name='startingAgainSmokingReason'
                      value={startingAgainSmokingReason ?? ''}
                      onChange={handleItemChange}
                    />
                  </FloatingLabel>
                </Form.Group>
                <Form.Group as={Col}>
                </Form.Group>
              </Row>

              <Row className='mt-3'>
                <Form.Group as={Col}>
                <Form.Label className='text-gray-600'>Sigara içme isteğinizi artıran nedenler nelerdir?</Form.Label>
                  <Form.Check
                    type='checkbox'
                    checked={reasonOfWantingSmokeAlcohol ?? false}
                    id='reasonOfWantingSmokeAlcohol'
                    name='reasonOfWantingSmokeAlcohol'
                    label='Alkol'
                    className='mb-2'
                    onChange={handleCheckBoxItemChange}
                  />
                  <Form.Check
                    type='checkbox'
                    checked={reasonOfWantingSmokeCoffee ?? false}
                    id='reasonOfWantingSmokeCoffee'
                    name='reasonOfWantingSmokeCoffee'
                    label='Kahve'
                    className='mb-2'
                    onChange={handleCheckBoxItemChange}
                  />
                  <Form.Check
                    type='checkbox'
                    checked={reasonOfWantingSmokeTea ?? false}
                    id='reasonOfWantingSmokeTea'
                    name='reasonOfWantingSmokeTea'
                    label='Çay'
                    className='mb-2'
                    onChange={handleCheckBoxItemChange}
                  />
                  <Form.Check
                    type='checkbox'
                    checked={reasonOfWantingSmokeStres ?? false}
                    id='reasonOfWantingSmokeStres'
                    name='reasonOfWantingSmokeStres'
                    label='Stres'
                    className='mb-2'
                    onChange={handleCheckBoxItemChange}
                  />
                  <Form.Check
                    type='checkbox'
                    checked={reasonOfWantingSmokeAfterDinner ?? false}
                    id='reasonOfWantingSmokeAfterDinner'
                    name='reasonOfWantingSmokeAfterDinner'
                    label='Yemek Sonrası'
                    className='mb-2'
                    onChange={handleCheckBoxItemChange}
                  />
                  <Form.Check
                    type='checkbox'
                    checked={reasonOfWantingSmokeFocus ?? false}
                    id='reasonOfWantingSmokeFocus'
                    name='reasonOfWantingSmokeFocus'
                    label='Odaklanma'
                    className='mb-2'
                    onChange={handleCheckBoxItemChange}
                  />

                  <Form.Control
                    className='mb-3'
                    value={reasonOfWantingSmokeDesc ?? ''}
                    id='reasonOfWantingSmokeDesc'
                    name='reasonOfWantingSmokeDesc'
                    type='textarea'
                    as="textarea"
                    placeholder='Başka varsa lütfen belirtiniz...'
                    style={{ width: '350px' }}
                    onChange={handleItemChange}
                  />
                </Form.Group>
                <Form.Group as={Col}>
                <Form.Label className='text-gray-600'>Daha önce sigarayı bırakmak için tedavi aldınız mı?</Form.Label>
                  <Form.Check
                    type='checkbox'
                    checked={appliedOldMedicationNRT ?? false}
                    id='appliedOldMedicationNRT'
                    name='appliedOldMedicationNRT'
                    label='NRT'
                    className='mb-2'
                    onChange={handleCheckBoxItemChange}
                  />
                  <Form.Check
                    type='checkbox'
                    checked={appliedOldMedicationBupropion ?? false}
                    id='appliedOldMedicationBupropion'
                    name='appliedOldMedicationBupropion'
                    label='Bupropion'
                    className='mb-2'
                    onChange={handleCheckBoxItemChange}
                  />
                  <Form.Check
                    type='checkbox'
                    checked={appliedOldMedicationVareniklin ?? false}
                    id='appliedOldMedicationVareniklin'
                    name='appliedOldMedicationVareniklin'
                    label='Vareniklin'
                    className='mb-2'
                    onChange={handleCheckBoxItemChange}
                  />
                  <Form.Check
                    type='checkbox'
                    checked={appliedOldMedicationCytisine ?? false}
                    id='appliedOldMedicationCytisine'
                    name='appliedOldMedicationCytisine'
                    label='Cytisine'
                    className='mb-2'
                    onChange={handleCheckBoxItemChange}
                  />

                  <Form.Control
                    className='mb-3'
                    value={appliedOldMedicationDesc ?? ''}
                    id='appliedOldMedicationDesc'
                    name='appliedOldMedicationDesc'
                    type='textarea'
                    as='textarea'
                    placeholder='Başka varsa lütfen belirtiniz...'
                    style={{ width: '350px' }}
                    onChange={handleItemChange}
                  />
                </Form.Group>
              </Row>

              <Row className='mb-3 mt-3'>
                <Form.Group as={Col}>
                  <Button variant='primary' onClick={handleSave}>
                    Kaydet
                  </Button>
                </Form.Group>
              </Row>
            </Form>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  )
}

export default PatientGeneralClinicInfo
